import { render, staticRenderFns } from "./LandingPageTypeOfInsuranceComponent.vue?vue&type=template&id=7783b092&scoped=true&"
import script from "./LandingPageTypeOfInsuranceComponent.vue?vue&type=script&lang=js&"
export * from "./LandingPageTypeOfInsuranceComponent.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageTypeOfInsuranceComponent.vue?vue&type=style&index=0&id=7783b092&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7783b092",
  null
  
)

export default component.exports